module.exports = __webpack_public_path__ + "static/scale-model-of-pittsburgh-party-pedaler-in-pittsburgh-pennsylvania-47ca3d0107c4e5d059e0b5452c5cfe75.png";